import { createFileRoute } from '@tanstack/react-router';
import { TenantSettingsPage } from 'src/modules/settings/components/pages/tenant-settings.page';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';

export const Route = createFileRoute('/settings/tenant')({
  component: TenantSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
